import { launcherApi } from '../api/launcher';
import { errorMessage, useApp } from '../app-context';
import { usePoll } from '../hooks/usePoll';
import { ErrorAlert } from '../components/ui';
import { formatDateTime } from '../format';
export function DiscordLinksSection() {
  const { canOperate, notify } = useApp();
  const links = usePoll(() => launcherApi.links(), 30000);
  const unlink = async (uuid: string) => {
    try {
      await launcherApi.unlink(uuid);
      await links.reload();
    } catch (error) {
      notify(errorMessage(error), true);
    }
  };
  return (
    <section className="card card-body stack">
      <h2 data-search-id="discord">Discord 連携</h2>
      <ErrorAlert error={links.error} />
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Minecraft 名</th>
              <th>Discord 名</th>
              <th>連携日時</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {(links.data ?? []).map((link) => (
              <tr key={link.uuid}>
                <td>{link.minecraftName}</td>
                <td>{link.globalName ?? link.username}</td>
                <td>{formatDateTime(link.linkedAt)}</td>
                <td>
                  {canOperate && (
                    <button className="btn small" onClick={() => void unlink(link.uuid)}>
                      解除
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
